"use strict";
angular.module('far.profile')
    .controller('ProfileSidebarController', function (form, userSendings, $timeout, $http, $filter) {

        var vm = {
            sidebarFrom: form('sidebarFrom'),
            isAdmin : false,
            userId : 0,
            progress : false,
            progressStack : [],
            sendingsData: null,
            show_address_modal: false,
            address_modal_text: '',
            address_modal_title: 'Адрес доставки',
            address_modal_btn_text: '',
            show_request_sent_popup: false,
            init: function(userId, isAdmin) {
                vm.isAdmin = isAdmin;
                vm.userId = userId;
                vm.pushProgress();
                vm.sendingsData = userSendings.get(userId, function() {
                    vm.popProgress();
                    vm.updateIsMemberCardSentLabel();
                });
            },
            showRequestSentPopup: function() {
                vm.show_request_sent_popup = true;
                vm.show_address_modal = false;
                return false;
            },
            pushProgress : function() {
                vm.progressStack.push(1);
                vm.progress = true;
            },
            popProgress : function() {
                vm.progressStack.pop();
                if (vm.progressStack.length == 0) {
                    vm.progress = false;
                }
            },
            updateIsMemberCardSentLabel: function() {
                var label = 'Карта отправлена';
                if (vm.sendingsData && vm.sendingsData.is_member_card_sent) {
                    label += ' (' + vm.sendingsData.member_card_sent + ')';
                }
                vm.sidebarFrom.$fields.isMemberCardSent.label = label;
            },
            showAddressPopup: function() {
                if (vm.sendingsData.full_address) {
                    vm.address_modal_text = vm.sendingsData.full_address;
                    vm.address_modal_btn_text = 'Уточнить адрес';
                } else {
                    vm.address_modal_text = 'В вашем профиле не заполнен адрес. Заполните его пожалуйста.';
                    vm.address_modal_btn_text = 'Заполнить адрес';
                }
                vm.show_address_modal = true;
            },
            sendMemberCardAndSticker: function() {
                vm.sendingsData.send_member_card_and_sticker = true;
                vm.pushProgress();
                vm.sendingsData.saveSendMemberCardAndSticker(function() {
                    vm.popProgress();
                    vm.showAddressPopup();
                });
            },
            sendSticker: function() {
                vm.sendingsData.send_sticker = true;
                vm.pushProgress();
                vm.sendingsData.saveSendSticker(function() {
                    vm.popProgress();
                    vm.showAddressPopup();
                });
            },

        };

        vm.sidebarFrom.addField('isMemberCardSent', 'checkbox', {
            label: '',
            options: {
                ngChange: function () {
                    $timeout(function(){
                        vm.pushProgress();
                        vm.sendingsData.saveMemberCardSent(function() {
                            vm.popProgress();
                            vm.updateIsMemberCardSentLabel();
                        });
                    });
                }
            }
        });

        vm.updateIsMemberCardSentLabel();

        vm.sidebarFrom.addField('isMemberCardReceived', 'checkbox', {
            label: 'Карта получена',
            options: {
                ngChange: function () {
                    $timeout(function(){
                        vm.pushProgress();
                        vm.sendingsData.saveMemberCardReceived(function() {
                            vm.popProgress();
                        });
                    });
                }
            }
        });

        return vm;
    });
